import React from 'react';

import { Box } from '@/shared/ui';

import Typography from '@/shared/ui/typography/Text';

const Heading = ({ title, subtitle }: { title: string; subtitle: string }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Typography sx={{ fontWeight: 'bold', fontSize: '20px' }}>{title}</Typography>
      <Typography
        color='gx.subtext'
        sx={{ fontWeight: 500, fontSize: '14px' }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Heading;
